<template>
<div>
  <div id="modalAides">
    <Modal v-if="showModal" :closeButton="false">
        <template #body>
          <div class="w-100 text-center">
            <div>{{ messageAide }}</div>
            <br/>
            <button class="btn btn-bleu me-2" type="button" @click="closeAide()">Fermer</button>
          </div>
        </template>
    </Modal>
  </div>

  <h1 class="titre-bienvenue bleu">
  Bienvenue sur le service de vérification des avis
  </h1>
   <br /> 
 <br /> 
 <h4 class="bleu">Vérification de conformité</h4>
 <br />
  <br /> 
  <div class="d-flex justify-content-center align-items-center">
    <div class="p-3"><img class :src="handleImage(nomImage)" style="height:7rem;" /></div>
    <div class="p-3 conformite">{{ resultatConformite }}{{ messageConformite }}<button class="btn-aide me-2" type="button" @click="showAide()">?</button></div>
  </div>
 <br />
<slot></slot>{{ libelleConformite }}
 </div>
</template>

<script>
import Modal from "@/clir/components/Modal/Modal";

export default {
  name: "Conformite",
  props: {
    nomImage: { type: String, default: '' },
    resultatConformite: { type: String, default: '' },
    libelleConformite: { type: String, default: '' },
    messageAide: { type: String, default: '' },
    messageConformite: { type: String, default: '' }
  },
   data () {
    return {
      showModal: false
    }
  },
   methods: {
    showAide(){
      this.showModal=true;
    },
     closeAide(){
      this.showModal=false;
    }
  },
  components: { Modal }
};
</script>

<style>
.conformite {
  font-size: 22px;
  font-weight: bold;
}
.titre-bienvenue{
  width: 100%;
  margin-bottom: 1.25rem;
  font-weight: bold;
}
.bleu{
  color: #5D90C7;
}
.bg-verifavis{
  border-style: solid;
  border-color: #5D90C7;
}
.btn-aide {
    padding: 0 .35rem;
    font-size: .7rem;
    color: #000000;
    border-radius: 50%;
    border-width: thin;
    background-color: #FFFFFF;
    margin-left: 0.5rem;
}
.btn-retour {
  background-color: #FFFFFF;
  color: #5D90C7;
  border-bottom-color: #bdbbbb;
  border-right-color: #bdbbbb;
  border-top-color: #FFFFFF;
  border-left-color: #FFFFFF;
  border-width: 0.15em;
}
.page{
  width: 100%;
  height: 100%;
  min-height: inherit;
  display: flex;
  flex-direction: column;  
}
.contenu-page {
  margin: auto;
}
.bas-page {
  border-top: 1px solid #9e9e9e;
  font-size: 80%;
  color: #9e9e9e;
  text-align: center;
  width: 100%;
}
</style>
